import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import TempPassword from '../components/TempPassword'
import UserMaster from '../components/User/Master'
import { useDataContext } from '../contexts/DataContext'
import Layout from './Layout'

const PageUserForm = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()

  const { currentUserRole, currentUserTemporaryPassword } = useDataContext()

  useEffect(() => {
    if (currentUserRole !== 'admin') {
      navigate('/')
    }
  }, [currentUserRole, navigate])

  if (currentUserTemporaryPassword) {
    return (
      <Layout>
        <TempPassword />
      </Layout>
    )
  }

  if (currentUserRole !== 'admin') {
    return null 
  }

  return (
    <Layout>
      <h1>{id ? t('label.edit_user') : t('label.new_user')}</h1>
      <UserMaster id={id} />
    </Layout>
  )
}

export default PageUserForm
